import { useHistory } from 'react-router-dom'
import { formatDistance } from 'date-fns'

import itemsImage from 'assets/images/items_background.png'

import s from './RecentItems.module.css'

type Props = {
  items: Item[]
  companyId: string
}
const RecentItems = ({ items, companyId }: Props): JSX.Element => {
  const history = useHistory()

  const handleItemClick = (item: Item) => {
    if (item.item_type === 'assignment') {
      history.push(
        `projects/items?view_assignment=${item.id}&project_title=${item.title}`
      )
    } else {
      window.open(`/${companyId}/items/${item.id}`, '_blank')
    }
  }

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        {items?.map((item: Item) => (
          <div
            key={item.code}
            onClick={() => handleItemClick(item)}
            role="none"
            className={s.item}
          >
            <img src={itemsImage} alt={itemsImage} className={s.image} />
            <div className={s.body}>
              <div className={s.content}>
                <span className={s.title}>{item.title}</span>
                <span className={s.timeStamp}>
                  {formatDistance(new Date(item.created_at), new Date(), {
                    addSuffix: true,
                  })}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RecentItems
